var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ screenshot: _vm.grimoire.isScreenshot },style:({
    backgroundImage: _vm.grimoire.background
      ? ("url('" + (_vm.grimoire.background) + "')")
      : ''
  }),attrs:{"id":"app","tabindex":"-1"},on:{"keyup":_vm.keyup}},[(!_vm.players.length)?_c('Intro'):_vm._e(),(_vm.players.length)?_c('TownInfo'):_vm._e(),_c('TownSquare',{on:{"screenshot":_vm.takeScreenshot}}),_c('Menu',{ref:"menu"}),_c('EditionModal'),_c('RolesModal'),_c('ReferenceModal')],1)}
var staticRenderFns = []

export { render, staticRenderFns }